import { effect, Injectable } from "@angular/core";
import { loadKey } from "./models/loadKey";
import { _BaseLoadingService } from "./_base-loading.service";
import { ProgressBarService } from "src/app/features/shared/progress-bar/progress-bar.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

// Page-lock tijdens langlopende acties: content-overlay (zie CompositePageComponent) + knoppen
// met [loadKey]="loadKey.pageLock" [lockOnLoad]="true" disabled. Navigatie (tab-wissel,
// terug-knop, menu) blijft werken — zie ScreenLockService voor het zwaardere niveau.
@Injectable({
    providedIn: 'root'
})
export class PageLockService
    extends _BaseLoadingService
{

    private readonly __progressBarService = injectRequired(ProgressBarService);

    locked$$ = this.isLoading$$;

    constructor() {
        super(
            loadKey.pageLock
        )

        // Footer-progressbar meeschakelen met het lock: alléén Active — Mode/ProgressValue
        // blijven aan de aanroeper (zie bv. photoMainUpload$ / ImageTablistComponent).
        effect(() => this.__progressBarService.Active = this.isLoading$$());
    }

    add(): void {
        super._add();
    }

    addCount(value: number): void {
        super._addCount(value);
    }

    clear(): void {
        super._clear();
    }

    remove(): void {
        super._remove();
    }

    removeCount(value: number): void {
        super._removeCount(value);
    }

    reset(): void {
        super._clear();
    }

}
